/**
 * Configuracao de ambiente.
 *
 * Tudo aqui vem de variaveis `VITE_*`, que o Vite embute no bundle em TEXTO
 * CLARO. Quem abrir o site le. Portanto: so entra neste arquivo o que pode ser
 * publico — URL, numero de telefone comercial, nome de ambiente. Segredo, nunca.
 */

export type DataSource = "static" | "api"

function readDataSource(): DataSource {
  const raw = import.meta.env.VITE_DATA_SOURCE

  // Default explicito em "static": enquanto a API da BusiPet nao expuser os
  // endpoints publicos, o site precisa continuar de pe sozinho. Cair para
  // "api" por engano deixaria a pagina em branco em producao.
  if (raw === "api") return "api"
  return "static"
}

export const env = {
  /** De onde os dados do site sao lidos. Ver `src/services/index.ts`. */
  dataSource: readDataSource(),

  /** Base da API BusiPet. Obrigatoria quando dataSource === "api". */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",

  /** Ambiente do deploy, para diagnostico. */
  ambiente: import.meta.env.VITE_AMBIENTE ?? "local",

  /** Numero de WhatsApp comercial, em formato internacional, so digitos. */
  whatsappNumber: import.meta.env.VITE_WHATSAPP_NUMBER ?? "5584996712577",

  /** Destino do botao "Acessar area do cliente". Vazio mantem o aviso modal. */
  clientAreaUrl: import.meta.env.VITE_CLIENT_AREA_URL ?? "",

  /**
   * Destino da ficha de credenciamento (POST JSON). Vazia mantem o formulario
   * avisando que o canal ainda nao esta no ar — ver `services/accreditation.ts`.
   *
   * Em producao vale um caminho RELATIVO (`/api/credenciamento`): o endpoint e
   * servido pelo mesmo dominio do site, por um behavior do CloudFront. Isso e
   * o que faz nao existir CORS e o que coloca o endpoint atras do mesmo WAF da
   * distribuicao. URL absoluta tambem funciona, e ai CORS volta a ser problema
   * de quem publicar o endpoint.
   *
   * Nao ha token a embutir aqui — este arquivo e publico por definicao. Quem
   * autentica a chamada e o header que o CloudFront injeta na origem, que o
   * navegador nunca ve.
   */
  accreditationEndpoint: import.meta.env.VITE_ACCREDITATION_ENDPOINT ?? "",

  /**
   * ID do site no Umami. Vazio desliga a medicao — e o default, para que
   * ambiente local e execucao de teste nao poluam o painel de producao.
   *
   * Nao e segredo: o valor fica visivel no HTML da pagina, por definicao.
   */
  umamiWebsiteId: import.meta.env.VITE_UMAMI_WEBSITE_ID ?? "",

  /** Script do Umami. O default e o do Umami Cloud. */
  umamiScriptUrl: import.meta.env.VITE_UMAMI_SCRIPT_URL ?? "https://cloud.umami.is/script.js",
} as const
